// extracted by mini-css-extract-plugin
export default {"billing_data":"LA","delivery_details":"MA","details_wrapper":"NA","title":"OA","detail_item":"PA"};
    if(module.hot) {
      // 1726593106130
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  